module.exports = __webpack_public_path__ + "assets/urendeclareren2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren2.jpg
// module id = 367
// module chunks = 0